import { BookingOrderPage } from '@/app/pages/order/booking-order-page';
import { createFileRoute } from '@tanstack/react-router';

import { createBookingSearchSchema } from '@/features/booking/config/create-booking-search-schema';

export const Route = createFileRoute('/order/')({
  validateSearch: createBookingSearchSchema,
  loaderDeps: ({ search }) => ({ ...search }),
  component: BookingOrderPage,
});
